// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__18kxC","requiredAsterisk":"Info_requiredAsterisk__32WH4"};